import { useContext } from "react";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles.module.css";
import DateTimeHelpers from "helpers/DateTimeHelpers";
import { amountRoundOff } from "helpers/NumberFormatHelper";
import ShopContext from "context/ShopContext";
import * as EditedSaleHelper from "helpers/EditedSaleHelper";

export default function EditedSaleDetailsPopup({ open, onClose, editedSale }) {
  const { selectedShop } = useContext(ShopContext);

  if (!open || !editedSale) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const totalDiscount = editedSale?.sale?.discount + editedSale?.sale?.discount_applied_on_items;

  return (
    <div className={styles.popUp} onClick={handleBackdropClick}>
      <Grid container className={styles.billContentWrapper} onClick={(e) => e.stopPropagation()}>
        <Grid item xs={12} className={styles.headSec} mb={2}>
          <h3>Edited Sale Details</h3>
          <CloseIcon className={styles.icon} onClick={onClose} />
        </Grid>

        <Grid item xs={12} className={styles.headInfoSec}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Bill Number</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>{editedSale.billNo}</div>
              </div>
            </Grid>

            {totalDiscount > 0 && (
              <Grid item xs={6}>
                <div className={styles.priceTxt}>
                  <div className={styles.subTitle}>Discount</div>
                  <div className={styles.colon}>:</div>
                  <div className={styles.amountGray}>
                    <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
                    {amountRoundOff(totalDiscount)}
                  </div>
                </div>
              </Grid>
            )}

            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Create At</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>{DateTimeHelpers.formatDateTime(editedSale?.sale?.time)}</div>
              </div>
            </Grid>

            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Previous Payable</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>
                  <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
                  {amountRoundOff(editedSale.previousAmount || 0)}
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Edited Time</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>
                  {editedSale.editedAt ? DateTimeHelpers.formatDateTime(editedSale.editedAt) : "-"}
                </div>
              </div>
            </Grid>

            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>New Payable</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>
                  <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
                  {amountRoundOff(editedSale.newAmount || 0)}
                </div>
              </div>
            </Grid>

            {editedSale.sale?.cashier && (
              <Grid item xs={6}>
                <div className={styles.priceTxt}>
                  <div className={styles.subTitle}>Cashier</div>
                  <div className={styles.colon}>:</div>
                  <div className={styles.amountGray}>{editedSale.sale?.cashier?.name || "-"}</div>
                </div>
              </Grid>
            )}

            <Grid item xs={12}>
              <div className={styles.priceTxt} style={{ alignItems: "flex-start" }}>
                <div className={styles.subTitle}>Remark</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray} style={{ wordBreak: "break-word", flexDirection: "column" }}>
                  {EditedSaleHelper.splitRemarkLines(editedSale.remark).length > 0 ? (
                    EditedSaleHelper.splitRemarkLines(editedSale.remark).map((line, idx) => <div key={idx}>{line}</div>)
                  ) : (
                    <div>{editedSale.remark || "-"}</div>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className={styles.tableContainer}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ width: "10%" }}>No</th>
                <th style={{ width: "40%" }}>Items</th>
                <th style={{ width: "15%" }}>Qty</th>
                <th style={{ width: "15%" }}>Rate</th>
                <th style={{ width: "20%" }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {(editedSale.items || []).map((item, index) => (
                <tr key={index}>
                  <td style={{ width: "10%" }}>{index + 1}</td>
                  <td style={{ width: "40%" }}>{item.name}</td>
                  <td style={{ width: "15%" }}>{item.qty || 1}</td>
                  <td style={{ width: "15%" }}>{amountRoundOff(item.rate || 0)}</td>
                  <td style={{ width: "20%" }}>{amountRoundOff(item.payable || 0)}</td>
                </tr>
              ))}
              {(!editedSale.items || editedSale.items.length === 0) && (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                    No items found in this edited sale record
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Grid>
        <div style={{ height: "20px" }}></div>
      </Grid>
    </div>
  );
}
